(function () {
    "use strict";

    angular.module("app").component("habilNewComment", {
        templateUrl: "@/comments/new-comment.html",
        bindings: {
            // Should be used to avoid getting the correct Id from the commentsService
            ownerId: "<",
            // Inject the correct saveApi whose payload is of the shape
            // { OwnerId: guid, NotifyUserRoles: string[], OrganisationId: guid, Message: string, Important: boolean, AttachmentDto: {Name, Content}[] }
            saveApi: "<",
            // This is needed to determine which observable of the commentsService needs to be updated
            mode: "@"
        },
        controller: NewCommentController
    });

    NewCommentController.$inject = ["controllerDecorator", "commentsService", "user", "enumService",];
    function NewCommentController(controllerDecorator, commentsService, user, enumService) {
        const $controller = this;

        controllerDecorator.Decorate($controller, []);

        const screeningsServices = enumService.ScreeningServices;

        $controller.comment = { Message: "", Attachments: [], };

        $controller.Important = false;

        $controller.onFilesAdded = attachments => $controller.comment.Attachments.push(...attachments);

        $controller.removeAttachment = removeAttachment;
        $controller.saveComment = saveComment;

        $controller.recipients = [{ label: "Code_NVO_Secretariat", isSelected: false, role: "NVO_NOTIFICATIONS", }];

        $controller.IsNotification = isNotification;

        $controller.AllowedToSetImportantFlag = user.UserHasRoles.some((e) => e.RoleName == "NVO-App");

        activate();

        function activate() {
            handleRecipients();
        }

        function handleRecipients() {
            if (Array.isArray(commentsService.ICD)) {
                if (commentsService.ICD.includes(screeningsServices.ADIVSGRS))
                    $controller.recipients.push({ label: "Code_ADIVSGRS", isSelected: false, role: "CD_ADIV_NOTIFICATIONS", });
                if (commentsService.ICD.includes(screeningsServices.VSSE))
                    $controller.recipients.push({ label: "Code_VSSE", isSelected: false, role: "CD_VSSE_NOTIFICATIONS", });
                if (commentsService.ICD.includes(screeningsServices.FODECO))
                    $controller.recipients.push({ label: "Code_FODECO", isSelected: false, role: "CD_FODECO_NOTIFICATIONS", });
            }

            if (user.UserHasRoles.some((e) => e.RoleName == "NVO-SendNotificationToSo"))
                $controller.recipients.push({ label: "APP_VO", isSelected: false, role: "SO_NOTIFICATIONS", });
        }

        function getUserRolesBySelection() {
            return $controller.recipients.filter(r => r.isSelected).map(r => r.role);
        }

        function isForRequest() {
            return $controller.mode === "request";
        }

        function getIdToUse() {
            if ($controller.ownerId)
                return $controller.ownerId;

            return isForRequest() ? commentsService.RequestId : commentsService.DossierId;
        }

        function cleanComment() {
            $controller.comment = { Message: "", Attachments: [], };

            // Reset important flag
            $controller.Important = false;
        }

        function removeAttachment(index) {
            $controller.comment.Attachments.splice(index, 1);
            $controller.comment.Attachments = [...$controller.comment.Attachments];
        };

        function close() {
            $controller.panelOpen = false;
        }

        function saveComment() {
            const payload = { ...$controller.comment, };
            payload.OwnerId = getIdToUse();
            payload.Important = $controller.Important;
            payload.NotifyUserRoles = getUserRolesBySelection();
            payload.OrganisationId = commentsService.OrganisationId;

            getSaveApi()(payload, handleReturn, $controller.ShowError);

            function handleReturn(result) {
                if (!CheckResultReceived(result))
                    return;

                setCommentData(result.data);
            }
        }

        function setCommentData(data) {
            if (isForRequest())
                commentsService.Request$.set(data);
            else
                commentsService.Dossier$.set(data);

            cleanComment();
            $controller.recipients.forEach(r => r.isSelected = false);
            $controller.comment.Attachments = [];
            close();
        }

        function isNotification() {
            return $controller.recipients.some(r => r.isSelected);
        }

        function getSaveApi() {
            if (angular.isFunction($controller.saveApi))
                return $controller.saveApi;
            else if (isForRequest())
                return $controller.Api.SaveRequestComment;
            else
                return $controller.Api.SaveDossierComment;
        }
    }
})();